export default "__VITE_ASSET__CRQi_6ej__"